import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, withKeys as _withKeys, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$modal.modals.value, (modal) => {
    return (_openBlock(), _createBlock(_resolveDynamicComponent(modal), {
      tabindex: "0",
      onKeyup: _cache[0] || (_cache[0] = _withKeys(($event: any) => (_ctx.$modal.close()), ["esc"]))
    }, null, 32))
  }), 256))
}